export default __webpack_public_path__ + "static/media/asia_bg.0e3dc3ae.png";